module.exports = __webpack_public_path__ + "static/media/UnitedWay.04a0d921.jpg";